import {NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {SharedModule} from '../../shared/shared.module';
import { CmsModule } from '../../cms/cms.module';

import {NewsDetailComponent} from './news-detail/news-detail.component';
import {NewsListComponent} from './news-list/news-list.component';


const routes: Routes = [
  { path: '', component: NewsListComponent},
  { path: ':id', 
    data: { cmsPath: "news/"},
    component: NewsDetailComponent
  },
];

@NgModule({
  declarations: [NewsDetailComponent, NewsListComponent],
  imports: [
    CmsModule,
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
  
})
export class NewsPageModule {
}
